module.exports = __webpack_public_path__ + "media/images/icons/illustration/aanmelden-7964fb01ab631a40d2561cf88a73ef61.svg";